/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import {
	sidebarWrapperCollapsed,
	sidebarItem,
	sidebarWrapperExpanded,
	sidebarItemSelected,
	title,
	separator,
	sidebarTopItems,
	sidebarBottomItems,
	sidebarTopList,
	sidbarCollapse,
	sidebarTitle,
} from './styles';
import { Link } from './link';
import { StatefulTooltip } from '../Tooltip';
import { styled } from 'styletron-react';
import { IDummyProps, IItem } from './types';
import { useStyletron } from '../../Themes';

type EpoType = IDummyProps;

export const View = (props: EpoType) => {
	const [selected, setSelected] = React.useState(props.itemSelected);
	const [collapsed, setCollapsed] = React.useState(props.isExpanded);
	const [hoverCollapsed, setHoverCollapsed] = React.useState(false);
	const [hoverItem, setHover] = React.useState<any>({ status: false, item: '' });
	const [css] = useStyletron();

	const collapseHandler = (isExpanded: boolean | undefined) => {
		setCollapsed(isExpanded);
		props.onExpand && props.onExpand(isExpanded || false);
	};

	useEffect(() => {
		setSelected(props.itemSelected);
	}, [props.itemSelected]);

	useEffect(() => {
		collapseHandler(props.isExpanded);
	}, [props.isExpanded]);

	const handleKeyDown = (e: any, item: any) => {
		if (e.key === 'Enter') {
			setSelected(item.name);
			return item.action();
		}
	};

	const Item = styled('div', ({ open }: any) => ({
		backgroundColor: open ? 'var(--epods--color-sidebar-hover)' : 'inherit',
		color: 'var(--epods--color-grey-950)',
		':hover': {
			backgroundColor: 'var(--epods--color-sidebar-hover)',
			borderRight: '4px solid var(--epods--color-sidebar-hover)',
		},
	}));

	const hasSubItems = props.items && props.items.some((item: any) => item.iconAfter);
	var tabIndex = 1;

	const getItem = (item: IItem, index: number) => {
		const {
			wrap: ItemWrap = React.Fragment,
			wrapAnchor: ItemWrapAnchor = React.Fragment,
			wrapProps: itemWrapProps = {},
			tooltip,
		} = item;
		let Tooltip = React.Fragment,
			tooltipProps = {};
		if (!item.wrap && tooltip) {
			Tooltip = StatefulTooltip as any;
			tooltipProps = {
				anchor: { Anchor: 'span', anchorProps: { style: { display: 'block' } } },
				ignoreBoundary: true,
				...tooltip,
			};
		}
		return item.separator ? (
			<hr key={index} className={css(separator(!collapsed))} />
		) : (
			<ItemWrap key={index} {...itemWrapProps}>
				<ItemWrapAnchor>
					<Tooltip {...tooltipProps}>
						<Item
							className={
								selected === item.name
									? css(sidebarItemSelected(collapsed))
									: css(sidebarItem(collapsed))
							}
							open={item.subItemsOpen === true}
							key={item.name}
							onClick={() => (item.name ? setSelected(item.name) : null)}
							tabIndex={tabIndex++}
							onKeyDown={(e: any) => handleKeyDown(e, item)}
						>
							<Link
								bold
								htmlFor="sideBar"
								collapsed={collapsed || hasSubItems}
								iconBefore={item.icon}
								iconAfter={item.iconAfter}
								label={!collapsed ? '' : item.label}
								url={item.url}
								onClick={item.action}
								iconColor={
									hoverItem.status && hoverItem.item === item.name
										? 'var(--epods--color-background-btn-outline-hover)'
										: 'var(--epods--color-ds-dark)'
								}
								title={item.title}
								tabIndex={-1}
							/>
						</Item>
					</Tooltip>
				</ItemWrapAnchor>
			</ItemWrap>
		);
	};

	const listItems = (items: IItem[] | undefined) => {
		return (
			items &&
			items.map((item, index) =>
				item.itemsGroup ? (
					<React.Fragment key={index}>
						<hr className={css(separator(!collapsed))} />
						{item.itemsGroup.map(item => getItem(item, index))}
						<hr className={css(separator(!collapsed))} />
					</React.Fragment>
				) : (
					getItem(item, index)
				),
			)
		);
	};

	return (
		<div
			className={
				collapsed ? css(sidebarWrapperExpanded(props.alignItems)) : css(sidebarWrapperCollapsed(hasSubItems))
			}
		>
			<div className={css(sidebarTitle)}>
				{collapsed && props.title && (
					<div>
						<h4 className={css(title)}>{props.title}</h4>
						<hr className={css(separator(!collapsed))} />
					</div>
				)}
			</div>
			{props.collapseButtonPosition === 'top' && (
				<div>
					{props.collapseButton !== false && (
						<div>
							<Item
								className={css(sidebarItem(collapsed))}
								onClick={() => collapseHandler(!collapsed)}
								onKeyDown={(e: any) => e.key === 'Enter' && collapseHandler(!collapsed)}
								tabIndex={tabIndex++}
							>
								<Link
									htmlFor="sideBar"
									collapsed={collapsed || hasSubItems}
									iconBefore={!collapsed ? 'navigate_next' : 'navigate_before'}
									label={!collapsed ? '' : props.collapseButtonLabel}
									iconColor={
										hoverCollapsed
											? 'var(--epods--color-background-btn-outline-hover)'
											: 'var(--epods--color-ds-dark)'
									}
									tabIndex={-1}
								/>
							</Item>
						</div>
					)}
				</div>
			)}
			<div id="top" className={css(sidebarTopItems)}>
				<div id="list" className={css(sidebarTopList())}>
					{listItems(props.items)}
					{props.children}
				</div>
			</div>
			{props.collapseButtonPosition === 'bottom' && (
				<div id="bottom" className={css(sidebarBottomItems)}>
					{listItems(props.bottomItems)}
					{props.collapseButton !== false && (
						<div className={css(sidbarCollapse)}>
							<Item
								style={sidebarItem(collapsed)}
								onClick={() => collapseHandler(!collapsed)}
								onKeyDown={(e: any) => e.key === 'Enter' && collapseHandler(!collapsed)}
								tabIndex={tabIndex++}
							>
								<Link
									htmlFor="sideBar"
									collapsed={collapsed || hasSubItems}
									iconBefore={!collapsed ? 'navigate_next' : 'navigate_before'}
									label={!collapsed ? '' : props.collapseButtonLabel}
									iconColor={
										hoverCollapsed
											? 'var(--epods--color-background-btn-outline-hover)'
											: 'var(--epods--color-ds-dark)'
									}
									tabIndex={-1}
								/>
							</Item>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

View.defaultProps = {
	collapseButtonLabel: 'Collapse',
	collapseButtonPosition: 'bottom',
};
